import React from "react";
import TeamIcon from "@components/icons/TeamIcon";
import {
	Standing,
} from "@data-types/sport-stats/SportStatsTypes";
import { TeamStandingsLastFiveForm } from "@features/offer/shared/statistics/components/team-standings";
import TeamStandingsStatsStore from "@state/stores/offer/statistics/TeamStandingsStatsStore";
import { getTeamStandingsPromotionClass } from "@utils/statistics/utils-statistics";
import classnames from "classnames";

export const TeamStandingsItem = (props: {
	standing: Standing;
	store: TeamStandingsStatsStore;
	homeScore: number | undefined;
	awayScore: number | undefined;
	isAwayTeam: boolean | undefined;
}) => {
	const { isHome, isAway, isHighlighted } = props.store.getTeamMatch(
		props.standing,
		props.store.eventStore.teamOne,
		props.store.eventStore.teamTwo,
		props.store.hasBothTeamsInStanding
	);

	return (
		<tr
			className={classnames(
				"table__body__row table__row table--stand__row",
				{
					"is-home": isHome,
					"is-away": isAway,
				}
			)}
		>
			<td
				className={classnames(
					"table__body__cell table__cell table--stand__cell",
					{
						"is-highlighted": isHighlighted,
					}
				)}
			>
				{isHighlighted && (
					<span
						className={classnames("table--stand__highlight", {
							"is-home": isHome,
							"is-away": isAway,
						})}
					/>
				)}

				<span
					className={`tag tag--spot tag--spot--xxsml tag--spot--${getTeamStandingsPromotionClass(props.standing.promotion?.phase)}`}
				>
					{props.standing.position}
				</span>
			</td>

			<td className="table__body__cell table__cell table--stand__cell table--stand__grow">
				<TeamIcon
					showCountryFlag={
						props.store.eventStore.tournament?.showCountryFlag
					}
					flagCode={props.standing.countryCode}
					jerseyTypeAbrv={props.standing.jerseyTypeAbrv}
					className="u-icon u-icon--base u-mar--right--2"
					hasPlaceholder
				/>

				<span
					className={classnames("u-align--v--middle", {
						"u-color--sent--danger":
							props.standing.liveMatchWinnerCodeColumn?.trim(),
					})}
				>
					{props.standing.name}
				</span>
			</td>

			<td className="table__body__cell table__cell table--stand__cell">
				{props.homeScore !== undefined &&
					props.awayScore !== undefined &&
					(() => {
						return (
							<span
								className={classnames(
									"table--stand__score-square",
									{
										"is-draw":
											props.homeScore === props.awayScore,
										"is-win": !props.isAwayTeam
											? props.homeScore > props.awayScore
											: props.awayScore > props.homeScore,
										"is-loss": !props.isAwayTeam
											? props.awayScore > props.homeScore
											: props.homeScore > props.awayScore,
									}
								)}
							>
								{!props.isAwayTeam
									? `${props.homeScore}:${props.awayScore}`
									: `${props.awayScore}:${props.homeScore}`}
							</span>
						);
					})()}
			</td>

			<td className="table__body__cell table__cell table--stand__cell">
				<span
					className={classnames({
						"u-color--sent--danger":
							props.standing.liveMatchWinnerCodeColumn?.trim(),
					})}
				>
					{props.standing.matches}
				</span>
			</td>

			{(props.store.teamStandingsFilter === "short" ||
				!props.store.teamStandingsFilter) && (
				<td className="table__body__cell table__cell table--stand__cell table--stand__xxlrg">
					<TeamStandingsLastFiveForm
						recentForm={props.standing.recentForm}
					/>
				</td>
			)}

			{props.store.teamStandingsFilter === "full" ||
			!props.store.teamStandingsFilter ? (
				<>
					<td className="table__body__cell table__cell table--stand__cell">
						<span
							className={classnames({
								"u-color--sent--danger":
									props.standing.liveMatchWinnerCodeColumn ===
									"wins",
							})}
						>
							{props.standing.wins}
						</span>
					</td>

					<td className="table__body__cell table__cell table--stand__cell">
						<span
							className={classnames({
								"u-color--sent--danger":
									props.standing.liveMatchWinnerCodeColumn ===
									"draws",
							})}
						>
							{props.standing.draws}
						</span>
					</td>

					<td className="table__body__cell table__cell table--stand__cell">
						<span
							className={classnames({
								"u-color--sent--danger":
									props.standing.liveMatchWinnerCodeColumn ===
									"losses",
							})}
						>
							{props.standing.losses}
						</span>
					</td>

					<td className="table__body__cell table__cell table--stand__cell table--stand__med">
						<span
							className={classnames({
								"u-color--sent--danger":
									props.standing.liveMatchWinnerCodeColumn?.trim(),
							})}
						>
							{props.standing.scoresFor}:
							{props.standing.scoresAgainst}
						</span>
					</td>
				</>
			) : null}

			{(props.store.teamStandingsFilter === "short" ||
				!props.store.teamStandingsFilter) && (
				<td className="table__body__cell table__cell table--stand__cell table--stand__med">
					<span
						className={classnames({
							"u-color--sent--danger":
								props.standing.liveMatchWinnerCodeColumn?.trim(),
						})}
					>
						{props.standing.scoreDiffFormatted}
					</span>
				</td>
			)}

			{(props.store.teamStandingsFilter !== "last_five" ||
				!props.store.teamStandingsFilter) && (
				<td className="table__body__cell table__cell table--stand__cell table--stand__sml">
					<span
						className={classnames({
							"u-color--sent--danger":
								props.standing.liveMatchWinnerCodeColumn?.trim(),
						})}
					>
						{props.standing.points}
					</span>
				</td>
			)}
		</tr>
	);
};
